import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../../services/notification.service';
import { Subscription } from 'rxjs';
import { NotificationPanelComponent } from '../notification-panel/notification-panel.component';

@Component({
  selector: 'app-notification-bell',
  standalone: true,
  imports: [CommonModule, NotificationPanelComponent],
  templateUrl: './notification-bell.component.html',
  styleUrl: './notification-bell.component.css'
})
export class NotificationBellComponent implements OnInit, OnDestroy {
  private readonly notificationService = inject(NotificationService);

  unreadCount = 0;
  showPanel = false;

  private unreadCountSubscription?: Subscription;

  ngOnInit() {
    // Subscribe to unread count
    this.unreadCountSubscription = this.notificationService.unreadCount$.subscribe(
      count => {
        this.unreadCount = count;
      }
    );
  }

  ngOnDestroy() {
    this.unreadCountSubscription?.unsubscribe();
  }

  togglePanel() {
    this.showPanel = !this.showPanel;
  }

  closePanel() {
    this.showPanel = false;
  }

  // Close panel when clicking outside
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    const bellButton = document.getElementById('notification-bell-button');
    const panel = document.getElementById('notification-panel');

    if (bellButton && panel) {
      if (!bellButton.contains(target) && !panel.contains(target)) {
        this.closePanel();
      }
    }
  }
}
